

const ProductData = {
    phone: [
        {
            image:  require('../../Images/Mobile Devices/Apple/11.jpeg'),
            name: 'IPHONE 11',
            price: '220000',
          },
          {
            image: require('../../Images/Mobile Devices/Apple/11pro.webp'),
            name: 'IPHONE 11 Pro',
            price: '280000',
          },
          {
            image: require('../../Images/Mobile Devices/Apple/Xmaxa.jpg'),
            name: 'IPHONE XMax',
            price: '200000',
          },
          {
            image:  require('../../Images/Mobile Devices/Samsung/note5.jpg'),
            name: 'GALAXY NOTE 5',
            price: '170000',
          },
          {
            image: require('../../Images/Mobile Devices/Samsung/a40.jpg'),
            name: 'SAMSUNG A40',
            price: '150000',
          },
          {
            image: require('../../Images/Mobile Devices/Samsung/note8.jpg'),
            name: 'GALAXY NOTE 8',
            price: '250000',
          }
    ],

    tv: [
        {
            image:  require('../../Images/TV/Hisense/1.jpg'),
            name: 'HISENSE',
            price: '310000',
          },
          {
            image: require('../../Images/TV/Hisense/2.jpg'),
            name: 'HISENSE',
            price: '350000',
          },
          {
            image: require('../../Images/TV/Hisense/3.jpeg'),
            name: 'HISENSE',
            price: '350000',
          },
          {
            image:  require('../../Images/TV/Samsung/3.jpeg'),
            name: 'SAMSUNG',
            price: '300000',
          },
          {
            image: require('../../Images/TV/Samsung/7.webp'),
            name: 'SAMSUNG',
            price: '320000',
          },
          {
            image: require('../../Images/TV/Samsung/1.jpg'),
            name: 'SAMSUNG',
            price: '200000',
          }
    ]
}

export default ProductData;